var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAvatarDefault = function SvgAvatarDefault(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.807 44.827c-4.1 6.035-10.958 10.03-18.807 10.03-7.85 0-14.71-3.995-18.811-10.03-1.175-1.728-1.061-4.032.31-5.613 4.832-5.577 11.539 1.929 18.501 1.929 6.962 0 13.664-7.506 18.5-1.93 1.367 1.582 1.482 3.886.307 5.614zM32 9.143c7.57 0 13.714 6.14 13.714 13.714 0 7.58-6.144 13.714-13.714 13.714-7.575 0-13.714-6.134-13.714-13.714 0-7.575 6.14-13.714 13.714-13.714zM32 0C14.327 0 0 14.327 0 32c0 17.678 14.327 32 32 32 17.673 0 32-14.322 32-32C64 14.327 49.673 0 32 0z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 32,
    y1: 96,
    x2: 96,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#5B6DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B833E1"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarDefault);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar-default.7627fc648c36646794e12c79161b6590.svg";